export default __webpack_public_path__ + "static/media/404error.0a9eb33c.png";